export class AvailableShipmentTypeDTO {
	public shipmentTypes: string[];
	public disabledShipmentInfo: DisabledShipmentInfo[];
}

class DisabledShipmentInfo {
	public shipmentType: string;
	public eventInfo: EventInfo[];
	public errorCode: string;
}

class EventInfo {
	public title: string;
	public storageId: number;
	public eventUuid: string;
}


// WEBPACK FOOTER //
// ./src/app/models/available-shipment-types-dto.model.ts